const buttons = [
  {
    label: "Delete Project",
    icon: null,
    className: "pull-left btn btn-danger delete-project",
    attributes: {
      type: "button",
      title: "Deletes this project",
      "data-event-category": "Edit Chart Review Project",
      "data-event-action": "Delete Project",
    },
  },
  // {
  // 	displayFn: data => {
  // 		// display this button only when the project is closable
  // 		return data.model.getClosable();
  // 	},
  // 	label: "Close Project",
  // 	icon: null,
  // 	className: "pull-left btn btn-warning close-project",
  // 	attributes: {
  // 		"type": "button",
  // 		"title": "Sets the status of this project to closed",
  // 		"data-event-category": "Edit Chart Review Project",
  // 		"data-event-action": "Close Project"
  // 	}
  // },
  {
    displayFn: (data) => {
      // display this button only when the project is modifiable
      return data.model.getModifiable();
    },
    label: "Undo Changes",
    icon: null,
    className: "btn btn-link",
    attributes: {
      type: "reset",
      "data-event-category": "Edit Chart Review Project",
      "data-event-action": "Reset",
    },
  },
  {
    displayFn: (data) => {
      // display this button only when the project is modifiable
      return data.model.getModifiable();
    },
    label: "Save Project",
    icon: null,
    className: "btn btn-emphasized",
    attributes: {
      type: "submit",
      "data-event-category": "Edit Chart Review Project",
      "data-event-action": "Save Project",
    },
  },
];

export { buttons as default };
